"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _checkTypes = _interopRequireDefault(require("check-types"));

var _animatedScrollTo = _interopRequireDefault(require("animated-scroll-to"));

var _DualPanePage = _interopRequireDefault(require("../01_atoms/DualPanePage"));

var _isNative = _interopRequireDefault(require("../../lib/is-native"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var DualPanePageWithSelector = /*#__PURE__*/function (_Component) {
  _inherits(DualPanePageWithSelector, _Component);

  var _super = _createSuper(DualPanePageWithSelector);

  function DualPanePageWithSelector() {
    var _this;

    _classCallCheck(this, DualPanePageWithSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      shownOnRight: null,
      focusedLeftItemId: null
    };
    _this.showOnRight = _this.showOnRight.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DualPanePageWithSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!(0, _isNative["default"])() && _checkTypes["default"].nonEmptyString(window.location.hash)) {
        // Show component mentionned in URL hash if any
        var hash = window.location.hash.substr(1);

        var _hash$split = hash.split('/'),
            _hash$split2 = _slicedToArray(_hash$split, 2),
            id = _hash$split2[0],
            _hash$split2$ = _hash$split2[1],
            focusedLeftItemId = _hash$split2$ === void 0 ? null : _hash$split2$;

        var rightComponentByName = this.props.rightComponentByName;
        var shownOnRight = this.state.shownOnRight; // Don't do anything if there's already something shown on right pane

        if (shownOnRight) {
          return;
        } // Else, if hash represents an existing component, select it


        if (_checkTypes["default"].nonEmptyString(id) && rightComponentByName && rightComponentByName[id]) {
          this.setState({
            shownOnRight: id,
            focusedLeftItemId: _checkTypes["default"].nonEmptyString(focusedLeftItemId) ? focusedLeftItemId : null
          });
        }
      } else {
        this.selectDefaultComponentIfAppropriate();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          defaultRightComponent = _this$props.defaultRightComponent,
          defaultFocusedLeftItemId = _this$props.defaultFocusedLeftItemId;

      if (prevProps.defaultRightComponent !== defaultRightComponent || prevProps.defaultFocusedLeftItemId !== defaultFocusedLeftItemId) {
        this.selectDefaultComponentIfAppropriate();
      }
    }
  }, {
    key: "getRightComponent",
    value: function getRightComponent() {
      var rightComponentByName = this.props.rightComponentByName;
      var shownOnRight = this.state.shownOnRight;

      if (!_checkTypes["default"].nonEmptyObject(rightComponentByName) || !_checkTypes["default"].nonEmptyString(shownOnRight) || !rightComponentByName[shownOnRight]) {
        return function () {
          return null;
        };
      }

      return rightComponentByName[shownOnRight];
    }
  }, {
    key: "selectDefaultComponentIfAppropriate",
    value: function selectDefaultComponentIfAppropriate() {
      var _this$props2 = this.props,
          defaultRightComponent = _this$props2.defaultRightComponent,
          defaultFocusedLeftItemId = _this$props2.defaultFocusedLeftItemId,
          rightComponentByName = _this$props2.rightComponentByName;

      if (_checkTypes["default"].nonEmptyString(defaultRightComponent) && rightComponentByName && rightComponentByName[defaultRightComponent]) {
        this.setState({
          shownOnRight: defaultRightComponent,
          focusedLeftItemId: _checkTypes["default"].nonEmptyString(defaultFocusedLeftItemId) ? defaultFocusedLeftItemId : null
        });
      }
    }
  }, {
    key: "showOnRight",
    value: function showOnRight(componentName) {
      var focusedLeftItemId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var prevFocusedLeftItemId = this.state.focusedLeftItemId;

      if (!componentName && _checkTypes["default"].nonEmptyString(prevFocusedLeftItemId)) {
        var to = prevFocusedLeftItemId;
        var h = window.document.getElementById(to).getBoundingClientRect().top;
        (0, _animatedScrollTo["default"])([null, h], {
          elementToScroll: window.document.getElementById('dual-pane-app-wrapper')
        });
      }

      if (!(0, _isNative["default"])()) {
        window.location.hash = "".concat(componentName || '', "/").concat(focusedLeftItemId || '');
      }

      this.setState({
        shownOnRight: componentName,
        focusedLeftItemId: focusedLeftItemId
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          LeftComponent = _this$props3.leftComponent,
          rightComponentByName = _this$props3.rightComponentByName,
          props = _objectWithoutProperties(_this$props3, ["leftComponent", "rightComponentByName"]);

      var _this$state = this.state,
          _this$state$shownOnRi = _this$state.shownOnRight,
          shownOnRight = _this$state$shownOnRi === void 0 ? null : _this$state$shownOnRi,
          _this$state$focusedLe = _this$state.focusedLeftItemId,
          focusedLeftItemId = _this$state$focusedLe === void 0 ? null : _this$state$focusedLe;
      var RightComponent = this.getRightComponent();
      return /*#__PURE__*/_react["default"].createElement(_DualPanePage["default"], _extends({
        showOnRight: this.showOnRight,
        focusedLeftItemId: focusedLeftItemId,
        currentRightPaneComponentName: shownOnRight
      }, props, {
        leftComponent: LeftComponent,
        rightComponent: RightComponent
      }));
    }
  }]);

  return DualPanePageWithSelector;
}(_react.Component);

exports["default"] = DualPanePageWithSelector;